/* Emporium — The Wall: wall page + person page behaviour. */
(function () {
  if (window.__emporiumWall) return;
  window.__emporiumWall = true;

  var KEY = 'eWallLast';
  function store(v) { try { sessionStorage.setItem(KEY, v); } catch (e) {} }
  function recall() { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } }
  function forget() { try { sessionStorage.removeItem(KEY); } catch (e) {} }

  function prefetch(url) {
    if (!url) return;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    document.head.appendChild(l);
  }

  /* ---------- The Wall ---------- */
  function initWall(wall) {
    if (wall.dataset.eInit) return;
    wall.dataset.eInit = '1';

    function clearLeaving() {
      wall.querySelectorAll('.e-wall__item.is-leaving').forEach(function (el) { el.classList.remove('is-leaving'); });
    }

    wall.addEventListener('click', function (e) {
      var link = e.target.closest('[data-e-wall-link]');
      if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
      clearLeaving();
      var item = link.closest('.e-wall__item');
      if (item) item.classList.add('is-leaving');
    });

    /* Back on the wall after viewing someone: put their polaroid in view, so you keep your place. */
    var saved = (recall() || '').split('\n');
    var last = saved[0];
    var fromPath = saved[1];
    if (last) {
      forget();
      var ref = '';
      try { ref = document.referrer ? new URL(document.referrer).pathname : ''; } catch (e) {}
      var item = ref && ref === fromPath && wall.querySelector('[data-e-wall-handle="' + (window.CSS && CSS.escape ? CSS.escape(last) : last) + '"]');
      if (item) {
        item.classList.add('is-leaving');
        var r = item.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) item.scrollIntoView({ block: 'center' });
        setTimeout(function () { item.classList.remove('is-leaving'); }, 800);
      }
    }

    /* Coming back with the browser's Back button: clear the hand-off marker. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) clearLeaving(); });
  }

  /* ---------- One person's page ---------- */
  function initEntry(root) {
    if (root.dataset.eInit) return;
    root.dataset.eInit = '1';

    var prevUrl = root.dataset.prevUrl;
    var nextUrl = root.dataset.nextUrl;
    var wallUrl = root.dataset.wallUrl;
    if (root.dataset.handle) store(root.dataset.handle + '\n' + location.pathname);

    function go(url) { if (url) window.location.href = url; }

    document.addEventListener('keydown', function (e) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return;
      var t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      if (document.querySelector('details[open] .menu-drawer, .drawer.active, modal-dialog[open]')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(nextUrl); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(prevUrl); }
      else if (e.key === 'Escape') { go(wallUrl); }
    });

    /* Swipe the photo left for next, right for previous. */
    var area = root.querySelector('[data-e-wall-swipe]');
    if (area) {
      var sx = 0, sy = 0, tracking = false;
      area.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { tracking = false; return; }
        tracking = true;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
      }, { passive: true });
      area.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - sx;
        var dy = t.clientY - sy;
        if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        go(dx < 0 ? nextUrl : prevUrl);
      }, { passive: true });
    }

    /* Have the next and previous people ready before they're asked for. */
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 600); };
    idle(function () { prefetch(nextUrl); prefetch(prevUrl); });
  }

  function boot() {
    document.querySelectorAll('[data-e-wall]').forEach(initWall);
    document.querySelectorAll('[data-e-wall-entry]').forEach(initEntry);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
